'use client'

// ControlsHint — one quiet line telling you how to move, then it gets out of
// the way. Replaces ViewModeHint, which existed to explain switching between
// walking and the camera rig; there's only walking now, so the job is purely
// "here's how to get going" for someone who just arrived from a link.

import { useEffect, useState } from 'react'
import { ui, kawaii } from '../../lib/ui/theme'
import { hud } from '../../lib/ui/layout'

export function ControlsHint() {
  const [visible, setVisible] = useState(true)
  const [touch, setTouch] = useState(false)

  useEffect(() => {
    setTouch(!!window.matchMedia?.('(pointer: coarse)').matches)
    const t = setTimeout(() => setVisible(false), 9000)
    return () => clearTimeout(t)
  }, [])

  const text = touch
    ? 'drag the left side to walk  ·  drag the right side to look'
    : 'click to look  ·  W / S move  ·  A / D turn  ·  E whistle'

  return (
    // On a phone this is the one thing a first-timer must not miss, and
    // the bottom bands are where the feed and the status pill live. So it
    // floats over the world for its nine seconds, then is gone for good.
    <div
      className="fixed left-1/2 -translate-x-1/2 z-40 pointer-events-none select-none max-w-[92vw]"
      style={{
        bottom: touch ? '38%' : hud.hintBottom,
        opacity: visible ? 1 : 0,
        transition: 'opacity 700ms ease',
      }}
    >
      <div
        style={{
          padding: '8px 16px',
          borderRadius: kawaii.radiusPill,
          background: kawaii.cream,
          border: kawaii.outline,
          boxShadow: kawaii.dropSm,
          color: kawaii.ink,
          fontFamily: ui.font,
          fontSize: 12,
          fontWeight: 600,
          whiteSpace: 'nowrap',
        }}
      >
        {text}
      </div>
    </div>
  )
}

export default ControlsHint
